import { createSlice } from '@reduxjs/toolkit';

import { logout } from 'src/features/auth';
import { IUserProfileState } from 'src/features/profile';

import { getUserProfile } from './userProfileThunks';
import { USER_PROFILE_LOADING_KEY } from './userProfileThunks';

const initialState: IUserProfileState = {
	profile: null,
};

const userProfileSlice = createSlice({
	name: USER_PROFILE_LOADING_KEY,
	initialState,
	reducers: {
		clearUserProfile: (state) => {
			state.profile = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getUserProfile.fulfilled, (state, action) => {
			state.profile = action.payload;
		});

		builder.addCase(logout, (state) => {
			state.profile = null;
		});
	},
});

export const { clearUserProfile } = userProfileSlice.actions;
export default userProfileSlice.reducer;
